import libUrl from 'url';
import settings from '../settings';
import extend from 'extend';

function formatUrl(params) {
	const url = libUrl.parse(settings.host + '/' + params.pathname);
	delete params['pathname']
	extend(url, params);
	return libUrl.format(url);
}

function getHeaders() {
	return {
		'X-Api-Key': settings.apiKey
	}
}

export { formatUrl, getHeaders }


// WEBPACK FOOTER //
// ./src/api/base.js